// extracted by mini-css-extract-plugin
export var body = "Layout-module--body--330b2";
export var component = "Layout-module--component--25b2d";
export var fadePop = "Layout-module--fade-pop--d4db0";
export var growHeightIn = "Layout-module--grow-height-in--91027";
export var line = "Layout-module--line--659dd";
export var printheader = "Layout-module--printheader--d30dc";
export var rusilogo = "Layout-module--rusilogo--9eaeb";